import "./LoadingGate.css";

type Props = {
    title: string;
    subtitle: string;
};

export function LoadingGate({
    title,
    subtitle,
}: Props) {
    return (
        <div className="entry">
            <div className="panel">
                <div className="loading-wrap" aria-live="polite" aria-busy="true">
                    <div className="loading-spinner" />
                    <h1 className="title">{title}</h1>
                    <p className="subtitle">{subtitle}</p>
                </div>
            </div>
        </div>
    );
}
